import {config} from '@config';
import {Signal} from 'typed-signals';

import {MediaQueryScreenMode} from '@services/types';

export class MediaQuery {
  static singleton: MediaQuery;
  private screenMode: MediaQueryScreenMode | undefined = undefined;
  public onChange = new Signal<(type: MediaQueryScreenMode) => void>();

  static create(
    vars: Record<MediaQueryScreenMode, string> = config.mediaQueryString,
  ) {
    if (MediaQuery.singleton) {
      return MediaQuery.singleton;
    }
    return (MediaQuery.singleton = new MediaQuery(vars || {}));
  }

  constructor(private vars: Record<MediaQueryScreenMode, string>) {
    Object.keys(this.vars).map((key) => {
      const val = this.vars[key as MediaQueryScreenMode];
      const mql = window.matchMedia(val);
      mql.addEventListener('change', (mql) => {
        if (mql.matches) {
          this.changeScreenMode(key as MediaQueryScreenMode);
        }
      });
      if (mql.matches) {
        this.screenMode = key as MediaQueryScreenMode;
      }
    });
  }

  public isPhone() {
    return this.screenMode === 'phone';
  }

  public isDesktop() {
    return !this.isPhone();
  }

  public get mode() {
    return this.screenMode;
  }

  private changeScreenMode(current: MediaQueryScreenMode) {
    if (this.screenMode !== current) {
      this.screenMode = current;
      this.onChange.emit(this.screenMode);
    }
  }
}
